import Repository from "./Repository";

const countries = "/countries";

export default {
  getCountries: (params) => Repository.get(`${countries}/`, { params: params }),
  getCountry: (id) => Repository.get(`${countries}/${id}/`),
  updateCountry: (id, payload) =>
    Repository.patch(`${countries}/${id}/`, payload),
  createCountry: (payload) => Repository.post(`${countries}/`, payload),
};
